import { formatISO, parseISO } from 'date-fns';
import React from 'react';

import { priorities } from '../../../domain';
import { NormalizedAgents } from '../../../resources/agent/types';
import {
    DisplayDossierOverviewGroupedByPriorityAndSortedByDate,
    DisplayDossiersTodo,
} from '../../../resources/todo/types';

import { SingleDayTodo } from './SingleDayTodo';

type Props = {
    dossiers: DisplayDossiersTodo;
    agents: NormalizedAgents;
};

export const NextDaysTodo = ({ dossiers, agents }: Props): JSX.Element => {
    const dossiersSortedByDate: DisplayDossierOverviewGroupedByPriorityAndSortedByDate = {};
    // The purpose of this function is to sort dossiers by date before priority, to display it day by day
    priorities.forEach((priority) =>
        dossiers[priority].forEach((dossier) => {
            const taskDueDate = formatISO(dossier.task.dueDate);
            dossiersSortedByDate[taskDueDate] = {
                ...dossiersSortedByDate[taskDueDate],
                [priority]: [...(dossiersSortedByDate[taskDueDate]?.[priority] || []), dossier],
            };
        }),
    );
    return (
        <React.Fragment>
            {Object.keys(dossiersSortedByDate)
                // eslint-disable-next-line sonarjs/no-alphabetical-sort -- date keys are ISO strings, alphabetical sort is equivalent to chronological sort here
                .sort()
                .map((date, i) => (
                    <React.Fragment key={i}>
                        <SingleDayTodo
                            dossiers={dossiersSortedByDate[date]}
                            agents={agents}
                            date={parseISO(date)}
                            nextDays
                        />
                    </React.Fragment>
                ))}
        </React.Fragment>
    );
};
